export default __webpack_public_path__ + "static/media/Group 8671.e26597e6.svg";